export const SCHEDULE_STATUS_LABELS = {
  pending: 'Pendente',
  awaiting_window: 'Aguardando interação',
  sent: 'Enviado',
  failed: 'Falhou',
  cancelled: 'Cancelado',
};

export const SCHEDULE_STATUS_COMPACT_LABELS = {
  pending: 'Pendente',
  awaiting_window: 'Aguard. interação',
  sent: 'Enviado',
  failed: 'Falhou',
  cancelled: 'Cancelado',
};

export const GENERATION_STATUS_COMPACT_LABELS = {
  pending: 'Geração pend.',
  generating: 'Gerando',
  ready: 'Pronto',
  failed: 'Geração falhou',
};

export const GENERATION_STATUS_LABELS = {
  pending: 'Geração pendente',
  generating: 'Gerando',
  ready: 'Conteúdo pronto',
  failed: 'Geração falhou',
};

export const SCHEDULE_TYPE_LABELS = {
  one_off: 'Único',
  recurring: 'Recorrente',
};

export const CONTENT_GENERATION_MODE_LABELS = {
  runtime: 'No horário (runtime)',
  batch: 'Pré-geração (batch)',
};

export const STATUS_FILTER_OPTIONS = [
  { value: '', label: 'Todos os status' },
  { value: 'pending', label: 'Pendente' },
  { value: 'awaiting_window', label: 'Aguardando interação' },
  { value: 'sent', label: 'Enviado' },
  { value: 'failed', label: 'Falhou' },
  { value: 'cancelled', label: 'Cancelado' },
];

export const TIMEZONE_OPTIONS = [
  { value: 'America/Sao_Paulo', label: 'America/Sao_Paulo (Brasil)' },
  { value: 'UTC', label: 'UTC' },
];

export const DEFAULT_TIMEZONE = 'America/Sao_Paulo';

export const DEFAULT_BATCH_LEAD_DAYS = 1;

export const PER_PAGE = 20;

const padTime = (value) => String(value).padStart(2, '0');

export const HOUR_OPTIONS = Array.from({ length: 24 }, (_, hour) => ({
  value: String(hour),
  label: `${padTime(hour)}:00`,
}));

export const MINUTE_OPTIONS = Array.from({ length: 12 }, (_, index) => {
  const minute = index * 5;
  return {
    value: String(minute),
    label: padTime(minute),
  };
});

export const DAY_OF_WEEK_OPTIONS = [
  { value: '1', label: 'Segunda' },
  { value: '2', label: 'Terça' },
  { value: '3', label: 'Quarta' },
  { value: '4', label: 'Quinta' },
  { value: '5', label: 'Sexta' },
  { value: '6', label: 'Sábado' },
  { value: '0', label: 'Domingo' },
];

export const RECURRENCE_DAY_PRESETS = [
  { value: '*', label: 'Todos os dias' },
  { value: '1,2,3,4,5', label: 'Segunda a sexta' },
  { value: '0,6', label: 'Sábado e domingo' },
  { value: 'custom', label: 'Personalizado' },
];

export const RECURRENCE_PRESET_FILTER_OPTIONS = [
  { value: '', label: 'Todos os padrões' },
  ...RECURRENCE_DAY_PRESETS,
];

export const RECURRENCE_DAYS_FILTER_PREFIX = 'days:';

export const DEFAULT_RECURRENCE_MINUTE = '0';
export const DEFAULT_RECURRENCE_HOUR = '9';
export const DEFAULT_RECURRENCE_DAYS = '1,2,3,4,5';
export const DEFAULT_RECURRENCE_CRON = '0 9 * * 1-5';
